<template>
	<div id="app" lang="fa" class="">
		<router-view></router-view>
	</div>
</template>


<script>
	export default {
		name: 'app',
		components: {
		}
	}
</script>

<style>
	.container{direction: rtl;}
	*{text-align: right;}
</style>
